import React from 'react'

function DateTimeControl({
	time,
	timezone,
	onDecrease,
	onIncrease,
	disabled = false,
	isDarkMode = false,
	formatTime,
}) {
	return (
		<div className="flex items-center gap-2">
			<button
				onClick={onDecrease}
				disabled={disabled}
				className={`w-5 h-5 border rounded text-xs font-medium transition-colors ${
					isDarkMode
						? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
						: 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
				} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
			>
				−
			</button>
			<div className="min-w-0">
				<div
					className={`text-xs font-medium whitespace-nowrap ${
						isDarkMode ? 'text-gray-300' : 'text-gray-700'
					}`}
				>
					{time ? formatTime(time, timezone) : 'Loading...'}
				</div>
			</div>
			<button
				onClick={onIncrease}
				disabled={disabled}
				className={`w-5 h-5 border rounded text-xs font-medium transition-colors ${
					isDarkMode
						? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
						: 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
				} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
			>
				+
			</button>
		</div>
	)
}

export default DateTimeControl
